var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_209_66657)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8464 28.7294V35.5677C24.5047 35.5514 24.1665 35.5219 23.8322 35.4797V28.7294C23.8322 28.4494 24.0593 28.2224 24.3393 28.2224C24.6194 28.2224 24.8464 28.4494 24.8464 28.7294ZM15.175 25.2825C14.895 25.2825 14.668 25.5096 14.668 25.7896V35.5652C14.9777 36.0295 15.3167 35.5113 15.6821 35.9309V25.7896C15.6821 25.5095 15.4551 25.2825 15.175 25.2825ZM15.1751 10.4688C14.895 10.4688 14.668 10.6958 14.668 10.9758V11.7298C14.668 12.0098 14.895 12.2368 15.1751 12.2368C15.4551 12.2368 15.6821 12.0098 15.6821 11.7298V10.9758C15.6821 10.6958 15.4551 10.4688 15.1751 10.4688Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4298 28.3767C38.5043 28.5443 38.3815 28.7332 38.1981 28.7332H24.8096C24.548 28.7332 24.3359 28.5211 24.3359 28.2595V19.1846C24.3359 18.923 24.548 18.7109 24.8096 18.7109H38.1981C38.3815 18.7109 38.5043 18.8998 38.4298 19.0674L36.361 23.722L38.4298 28.3767Z",
    fill: "url(#paint1_linear_209_66657)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8618 28.7332H23.8477V18.7109H24.8618V28.7332ZM28.1299 18.7109H26.2536V28.7332H28.1299V18.7109ZM31.905 18.7109H30.0286V28.7332H31.905V18.7109ZM35.6801 18.7109H33.8038V28.7332H35.6801V18.7109Z",
    fill: "#BC435B",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3007 25.4402C35.3753 25.6078 35.2525 25.7966 35.0691 25.7966H15.6509C15.4424 25.7966 15.2734 25.6276 15.2734 25.4191V12.0572C15.2734 11.8487 15.4424 11.6797 15.6509 11.6797H35.069C35.2525 11.6797 35.3752 11.8685 35.3007 12.0362L32.322 18.7382L35.3007 25.4402Z",
    fill: "url(#paint2_linear_209_66657)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2278 18.768C18.1674 18.768 17.3047 17.9053 17.3047 16.845C17.3047 15.7846 18.1674 14.9219 19.2278 14.9219C20.2881 14.9219 21.1508 15.7846 21.1508 16.845C21.1508 17.9053 20.2881 18.768 19.2278 18.768Z",
    fill: "#F16480",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5637 18.768C22.5033 18.768 21.6406 17.9053 21.6406 16.845C21.6406 15.7846 22.5033 14.9219 23.5637 14.9219C24.6241 14.9219 25.4868 15.7846 25.4868 16.845C25.4868 17.9053 24.6241 18.768 23.5637 18.768Z",
    fill: "#F16480",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8801 18.768C26.8197 18.768 25.957 17.9053 25.957 16.845C25.957 15.7846 26.8197 14.9219 27.8801 14.9219C28.9405 14.9219 29.8032 15.7846 29.8032 16.845C29.8032 17.9053 28.9405 18.768 27.8801 18.768Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6821 11.6797V25.7967H14.668V11.6797H15.6821Z",
    fill: "#F0E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2131 19.4141H22.8836C21.6362 19.4141 20.625 20.4252 20.625 21.6726V22.0225C20.625 22.4955 21.0084 22.879 21.4814 22.879H26.0952C26.3031 22.879 26.4717 22.7104 26.4717 22.5025V21.6726C26.4717 20.4252 25.4604 19.4141 24.2131 19.4141Z",
    fill: "#F16480",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7795 19.4141H18.45C17.2026 19.4141 16.1914 20.4252 16.1914 21.6726V22.5026C16.1914 22.7105 16.36 22.879 16.5678 22.879H21.6616C21.8695 22.879 22.0381 22.7105 22.0381 22.5026V21.6726C22.0381 20.4252 21.0269 19.4141 19.7795 19.4141Z",
    fill: "#F16480",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6467 19.4141H27.3172C26.0698 19.4141 25.0586 20.4252 25.0586 21.6726V21.9931C25.0586 22.4823 25.4552 22.879 25.9445 22.879H30.5288C30.7367 22.879 30.9053 22.7105 30.9053 22.5026V21.6726C30.9052 20.4252 29.894 19.4141 28.6467 19.4141Z",
    fill: "#F16480",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_66657",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 45.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_66657",
    x1: 31.3939,
    y1: 18.7109,
    x2: 31.3939,
    y2: 28.7332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC859C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_66657",
    x1: 25.2982,
    y1: 11.6797,
    x2: 25.2982,
    y2: 25.7966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcons);
export default __webpack_public_path__ + "static/media/group-icons.0b709f6dd6606bf1136aa59ac8406b74.svg";
export { ForwardRef as ReactComponent };